export default function () {
	let filesRow = document.querySelectorAll('.files__row');
	for (let i = 0; i < filesRow.length; i++) {
		const element = filesRow[i];
		element.addEventListener('click', function () {
			element.classList.toggle('active');
		})
	}
}